import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import Select from 'react-select';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import moment from 'moment';
import * as actions from '../action';
import * as c from '../constant';

function UpdateAppointmentModal({
  createInputNumber,
  updateAppointments,
  formData,
  getAppointmentsList,
  showAppointment,
  setFormData,
  creating,
  appointmentData,
  getSystemModuleList,
  systemModuleList,
}) {
  const setModal = useContext(ModalContext);
  const periodOption = [
    { label: '6:30AM - 8:30AM', value: '6:30AM - 8:30AM' },
    { label: '9:30AM - 11:30AM', value: '9:30AM - 11:30AM' },
    { label: '1:00PM - 2:00PM', value: '1PM - 2PM' },
  ];
  const periodOptionOP = [
    { label: '7AM - 9AM', value: '7AM - 9AM' },
    { label: '10AM - 12NN', value: '10AM - 12NN' },
    { label: '1PM - 2PM', value: '1PM - 2PM' },
  ];

  const handleOnChangeDate =
    (key) =>
    ({ target: { value } }) => {
      setFormData({
        ...formData,
        [key]: value,
      });
    };

  const OnSetFormData = () => {
    setFormData({
      quota: _.get(appointmentData, 'attributes.quota') || '',
      system_module_id: _.get(appointmentData, 'attributes.system_module_id'),
      system_module_name: _.get(appointmentData, 'attributes.system_module'),
      period: {
        label: _.get(appointmentData, 'attributes.period'),
        value: _.get(appointmentData, 'attributes.period'),
      },
      appointment_date: _.get(appointmentData, 'attributes.appointment_date'),
    });
  };

  useEffect(() => {
    OnSetFormData();
  }, []);

  const handleOnChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: { label: e.value, value: e.value },
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      ...formData,
      period: _.get(formData, 'period.value'),
      system_module_id: _.get(formData, 'system_module_id'),
      appointment_date: moment(formData.appointment_date).format('YYYY-MM-DD'),
    };

    updateAppointments(_.get(appointmentData, 'id'), args, ({ data }) => {
      setModal({ isOpen: false });
      getAppointmentsList({
        system_module_id: _.get(data, 'attributes.system_module_id'),
      });
      showAppointment(data.id);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    getSystemModuleList();
  }, []);

  const systemModuleOption = systemModuleList.map((x) => ({
    label: _.get(x, 'attributes.description'),
    value: +x.id,
    id: x.id,
  }));

  const findValue =
    systemModuleOption.find(
      (item) => +_.get(formData, 'system_module_id') === +item.value
    ) || '';

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="form-label d-flex align-items-center">
              <span className="mr-auto mr-0 text-muted">Transaction</span>
            </label>
            <Select
              placeholder=""
              onChange={handleOnChangeSelect('system_module_id')}
              options={systemModuleOption}
              value={findValue}
              isDisabled
            />
          </div>
          <div className="col-12 form-group">
            {createInputNumber(
              { key: 'quota', label: 'Quota:' },
              { required: true, placeholder: 'No. of quota' }
            )}
          </div>
          <div className="col-12 form-group">
            <label className="form-label d-flex align-items-center">
              <span className="mr-auto mr-0 text-muted">Period</span>
            </label>
            <Select
              placeholder=""
              onChange={handleOnChangeSelect('period')}
              options={
                [5, 38, 39, 24].indexOf(+_.get(formData, 'system_module_id')) >
                  -1 &&
                ['HC', 'OHP', 'OP'].indexOf(
                  +_.get(formData, 'system_module_name')
                )
                  ? periodOptionOP
                  : periodOption
              }
              value={_.get(formData, 'period')}
            />
          </div>

          <div className="form-input-group col-12 col-md-12">
            <label className="form-control-plaintext text-muted">Date:</label>
            <DateInputPicker
              className="full-input"
              onChange={handleOnChangeDate('appointment_date')}
              value={moment(_.get(formData, 'appointment_date')).format(
                'MM-DD-YYYY'
              )}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={creating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateAppointmentModal.propTypes = {
  createInputNumber: PropTypes.instanceOf(Function).isRequired,
  getAppointmentsList: PropTypes.instanceOf(Function).isRequired,
  updateAppointments: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  appointmentData: PropTypes.instanceOf(Object).isRequired,
  showAppointment: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
  getSystemModuleList: PropTypes.instanceOf(Function).isRequired,
  systemModuleList: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  roleList: _.get(api, `${c.GET_ROLE_LIST}.list`) || [],
  creating: api.loading.indexOf(c.CREATE_APPOINTMENTS) > -1,
  systemModuleList: _.get(api, `${c.GET_SYSTEM_MODULES}.res.data`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateAppointmentModal);
